<div
  role="dialog"
  aria-labelledby="modalResponseFastMessage"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalResponseFastMessage">
          {{ 'shared.modalResponseFast.send' | translate }} {{ !previewOnly ? ('shared.modalResponseFast.quickReply' | translate) : ('shared.modalResponseFast.buttons' | translate) }}
          <br />
          <span class="text-muted fw-normal font-14"
            >{{ 'shared.modalResponseFast.selectResponseToSend' | translate }}</span
          >
        </h4>
        <button
          type="button"
          class="btn-close"
          [mat-dialog-close]="true"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        <div class="row">
          <div class="col-sm-10 input-trend-search">
            <input
              class="form-control w-100"
              type="search"
              #searchBox
              (keyup)="search(searchBox.value)"
              [placeholder]="'shared.modalResponseFast.searchPlaceholder' | translate"
            />
            <span class="mdi mdi-magnify search-icon"></span>
          </div>
          <div class="col-sm-2 trend-button">
            <button
              type="submit"
              [matMenuTriggerFor]="menu"
              class="btn btn-primary dropdown-toggle"
            >
              {{ 'shared.modalResponseFast.categories' | translate }} <span class="caret"></span>
            </button>
          </div>
          <mat-menu #menu class="menu-content">
            <button (click)="selectedCategory('')" mat-menu-item>{{ 'shared.modalResponseFast.all' | translate }}</button>
            @for (category of listCategory; track $index) {
              <button (click)="selectedCategory(category.name)" mat-menu-item>
                {{ category ? category.name : "" }}
              </button>
            }
          </mat-menu>
        </div>

        @if (loadingSpinner$ | async) {
          <loading-component />
        }

        @if (!(loadingSpinner$ | async) && pager.total > 0) {
          <div class="card-body table-responsive">
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'shared.modalResponseFast.name' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.modalResponseFast.category' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.modalResponseFast.message' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.modalResponseFast.type' | translate }}</th>
                  <th class="sr-only custom-button-select">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                @for (item of pager.list; track $index) {
                  <tr>
                    <td>
                      {{ item.name || "-" }}
                    </td>
                    <td>
                      {{ item.category ? item.category.name : "N/A" }}
                    </td>
                    <td>
                      {{ item.message | truncate: 50 }}
                    </td>
                    <td>
                      {{ getFileExtension(item) }}
                    </td>
                    <td>
                      <button
                        class="btn btn-sm btn-dark"
                        (click)="selectedResponseFast(item)"
                      >
                        <i class="ri-check-line"></i>
                        {{ 'shared.modalResponseFast.select' | translate }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (pager.total > pager.perPage) {
              <paginator
                class="flex justify-content-center mt-3 mb-3"
                [pager]="pager"
                (onPager)="loadPage($event)"
              />
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
